import { useEffect, useState } from "react";
import { getConferenceInformation } from "./ConferenceInformation";
import { getPublicProfiles } from "./PublicProfiles";
import { getEventById } from "./Events";
import { useMsal } from "@azure/msal-react";
import { getAuthUserProfile } from "../auth/AuthServices";
import { useGlobal } from "../../utils/GlobalContext";
import { newAuthUser } from "../../data/auth/authUser";


export function CDNContent(){
    const [isLoaded, setIsLoaded] = useState(false);
    const { instance } = useMsal();
    const { state, dispatch } = useGlobal();
    useEffect(()=>{
        if(state.Conference.Name==="")
            fetchConference();
        if(state.Profiles.length===0)
            fetchProfiles();
        if(state.UserProfile!==newAuthUser()&&isLoaded===true){
            setIsLoaded(false);
        }
        if(isLoaded===false){
            if(instance.getActiveAccount()?.idTokenClaims && state.UserProfile?.DisplayName==="")
                fetchAuthProfile();
        }
    });
    const fetchAuthProfile = async () =>{
       
        try {
            const data = await getAuthUserProfile();
            if(data!==null){
                dispatch({ type: 'SET_USERPROFILE', UserProfile: data });
            }
            setIsLoaded(true);
        } catch (err) {
            alert(err)
            console.error("Failed to fetch Conferernce Information." + err);
        }
    };


    const fetchConference = async () =>{
        const cinfo = await getConferenceInformation();
        if(cinfo!==null && cinfo!==undefined){
            dispatch({ type: 'SET_CONFERENCE', Conference: cinfo });
            if(cinfo.CurrentEventId!==null || cinfo.CurrentEventId!==""){
                dispatch({ type: 'SET_SELECTEDEVENTID', SelectedEventId: cinfo.CurrentEventId });
                fetchEventId(cinfo.CurrentEventId);
            }
        }
    };
    const fetchProfiles = async () =>{
        const data= await getPublicProfiles();
        if(data!==null){
            dispatch({ type: 'SET_PROFILES', Profiles: data });
        }
    };
    const fetchEventId = async (eventId: string) =>{
        if(eventId==='00000000-0000-0000-0000-000000000000')
            return;
        const data= await getEventById(eventId);
        if(data!==null){
            dispatch({ type: 'SET_SELECTEDEVENT', SelectedEvent: data});
        }
    };
    return <></>;
}
